var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9516E8F6-C068-4EDE-9B68-D898E0CAE70D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.882353 0 0 0 0 0.741176 0 0 0 0 0.262745 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.0_Support_3",
    transform: "translate(-1108.000000, -271.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(530.000000, 271.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    transform: "translate(578.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 18 0 18 18 0 18"
  }), /*#__PURE__*/React.createElement("g", {
    id: "foreign-(1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.750000, 0.750000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7499604,0 L9.74996631,0 C9.33575911,0 8.99995898,0.335800125 8.99995898,0.750007324 C8.99995898,1.16421452 9.33575911,1.50001465 9.74996631,1.50001465 L13.9393146,1.50001465 L6.21968219,9.21967926 C5.92677553,9.51258591 5.92677553,9.98741116 6.21968219,10.2803178 C6.36608718,10.426755 6.55802821,10.4999736 6.74996924,10.4999736 C6.94191027,10.4999736 7.13388353,10.4267873 7.28032074,10.2802856 L14.9999854,2.5606532 L14.9999854,6.75000146 C14.9999854,7.16420866 15.3357855,7.5 15.7499927,7.5 C16.1641999,7.5 16.5000022,7.16420866 16.5000022,6.75000146 L16.5000022,0.750007324 C16.5000022,0.335800125 16.1641676,0 15.7499604,0 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7499634,7.49997656 C12.3357562,7.49997656 11.9999561,7.83577669 11.9999561,8.24998389 L11.9999561,14.9999854 L1.49998242,14.9999854 L1.49998242,4.49997949 L8.24998389,4.49997949 C8.66419109,4.49997949 9,4.16417937 9,3.74997217 C9,3.33576497 8.66419109,2.99999707 8.24998389,2.99999707 L0.750007324,2.99999707 C0.335800125,2.99999707 0,3.3357972 0,3.75000439 L0,15.7499927 C0,16.1641676 0.335800125,16.4999678 0.750007324,16.4999678 L12.7499956,16.4999678 C13.1642028,16.4999678 13.5,16.1641676 13.5,15.7499604 L13.5,8.24998389 C13.5,7.83577669 13.1641706,7.49997656 12.7499634,7.49997656 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLinkIcon);
export default __webpack_public_path__ + "static/media/OpenLinkIcon.216b4fab5de89045c2dc9668f228b4a2.svg";
export { ForwardRef as ReactComponent };